var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlancConfort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 525.89 279.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        filter: url(#drop-shadow-3);\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5, .cls-6 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2, .cls-3, .cls-5 {\n        fill: none;\n      }\n\n      .cls-2, .cls-5 {\n        stroke-width: .75px;\n      }\n\n      .cls-2, .cls-6 {\n        stroke: #e63d11;\n      }\n\n      .cls-7, .cls-6 {\n        fill: #e63d11;\n      }\n\n      .cls-8 {\n        fill: url(#D\xE9grad\xE9_sans_nom_9);\n      }\n\n      .cls-9 {\n        fill: url(#D\xE9grad\xE9_sans_nom_53);\n        opacity: .5;\n      }\n\n      .cls-9, .cls-10, .cls-11, .cls-12, .cls-13 {\n        mix-blend-mode: multiply;\n      }\n\n      .cls-10 {\n        fill: url(#D\xE9grad\xE9_sans_nom_13);\n      }\n\n      .cls-10, .cls-11 {\n        opacity: .6;\n      }\n\n      .cls-11 {\n        fill: url(#D\xE9grad\xE9_sans_nom_49);\n      }\n\n      .cls-3 {\n        stroke-width: 7px;\n      }\n\n      .cls-3, .cls-4, .cls-5 {\n        stroke: #fff;\n      }\n\n      .cls-14 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-15 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-12 {\n        opacity: .9;\n      }\n\n      .cls-16 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-17 {\n        fill: url(#D\xE9grad\xE9_sans_nom_9-2);\n      }\n\n      .cls-18 {\n        fill: url(#D\xE9grad\xE9_sans_nom_9-3);\n      }\n\n      .cls-19 {\n        isolation: isolate;\n      }\n\n      .cls-4, .cls-20 {\n        fill: #fff;\n      }\n\n      .cls-4, .cls-6 {\n        stroke-width: .5px;\n      }\n\n      .cls-21 {\n        fill: #e30613;\n      }\n\n      .cls-22 {\n        opacity: .8;\n      }\n\n      .cls-13 {\n        fill: url(#D\xE9grad\xE9_sans_nom_56);\n      }\n\n      .cls-23 {\n        fill: #b2b2b2;\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-3",
    x: 382.14,
    y: 156,
    width: 152.64,
    height: 136.8,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.67,
    dy: 5.67
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_53",
    "data-name": "D\\xE9grad\\xE9 sans nom 53",
    x1: 408.24,
    y1: 213.27,
    x2: 421.76,
    y2: 213.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#12120d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_49",
    "data-name": "D\\xE9grad\\xE9 sans nom 49",
    x1: 428.84,
    y1: 210.75,
    x2: 424.73,
    y2: 214.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12120d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_13",
    "data-name": "D\\xE9grad\\xE9 sans nom 13",
    x1: 407.76,
    y1: 224.99,
    x2: 423.65,
    y2: 224.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#dededd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#b7b7b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#81817e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#3d3d39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#12120d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_56",
    "data-name": "D\\xE9grad\\xE9 sans nom 56",
    x1: 429.78,
    y1: 224.4,
    x2: 439.04,
    y2: 224.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#12120d",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#41413d",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#838381",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#b8b8b7",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#dfdfde",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#f6f6f6",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 445.06,
    y1: 211.62,
    x2: 426.68,
    y2: 227.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 426.58,
    y1: 201.74,
    x2: 414.3,
    y2: 212.54,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 433.91,
    y1: 207.41,
    x2: 420.94,
    y2: 218.81,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_9",
    "data-name": "D\\xE9grad\\xE9 sans nom 9",
    x1: 425.39,
    y1: 228.68,
    x2: 407.27,
    y2: 237.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#d3d3d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#8f8f8d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#595956"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#32322e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1a1a15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12120d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_9-2",
    "data-name": "D\\xE9grad\\xE9 sans nom 9",
    x1: 416.28,
    y1: 210.37,
    x2: 403.38,
    y2: 216.79,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_9-3",
    "data-name": "D\\xE9grad\\xE9 sans nom 9",
    x1: 420.66,
    y1: 219.16,
    x2: 402.53,
    y2: 228.17,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "384.03 158.06 384.03 170.41 384.43 170.41 403.78 170.41 403.8 152.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M61,35.18c1.54-1.87,3.56-4.02,6.16-6.16,2.32-1.91,4.56-3.36,6.51-4.45h23.71c.9.59,2.21,1.5,3.68,2.74,6.19,5.22,9.14,11.13,11.13,15.24,5.63,11.6,8.44,17.4,10.62,22.26,2.28,5.11,5.67,12.48,10.1,21.38l21.4-52.89c.41-1.19,1.63-4.24,4.79-6.51,2.06-1.47,4.09-2.01,5.29-2.23h23.54c1.89.41,5.74,1.55,8.49,4.97,3.42,4.25,3.06,9.47,2.74,14.04-.19,2.69-.82,6.93-3.07,11.8l-41.1,72.78v53.76h-35.91c-.79-.27-1.96-.76-3.13-1.71-2.96-2.4-3.69-5.89-4.11-7.88-.25-1.18-.5-2.95-.34-5.14v-38.69L61,35.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M229.98,73.93c6.33,0,11.47,5.14,11.47,11.47s-5.14,11.47-11.47,11.47-11.47-5.14-11.47-11.47,5.14-11.47,11.47-11.47ZM220.09,105.56h19.77v64.06h-19.77v-64.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M316.61,160.65c-.23-.43-.44-.87-.63-1.32M317.34,161.89c-.26-.4-.5-.82-.73-1.24M357.81,163.09v-1.4h-.26c-.2.32-.41.63-.63.92M315.97,159.33c-.99-2.28-1.53-4.88-1.53-7.79,0-22.14,26.89-22.54,43.36-22.54,0-6.99-5.8-11.47-12.65-11.47-6.46,0-11.86,2.9-16.08,7.64l-10.54-10.81c7.25-6.85,17.79-10.28,28.21-10.28,23.07,0,29.26,11.73,29.26,33.08v21.79M352.93,141.65c-6.06,0-19.51.53-19.51,9.23,0,4.75,5.01,6.99,9.36,6.99,7.78,0,15.03-4.09,15.03-12v-4.22h-4.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M190.63,70.51h19.77v99.65h-19.77v-99.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M384.03,157.02v-50.87h19.77v10.28h.26c4.22-7.78,9.75-11.86,18.45-11.86,2.24,0,4.75.13,6.59.66v18.06c-2.77-.79-5.54-1.32-8.44-1.32-15.03,0-16.87,8.7-16.87,21.49v9.09"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 444.73,
    cy: 116.67,
    r: 9.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M289.79,159.68v-20.67c0-7.38-.13-16.87-10.28-16.87s-11.86,8.04-11.86,16.34v31.9h-19.77v-64.06h18.98v8.7h.26c2.64-5.01,9.1-10.28,18.72-10.28,20.03,0,23.72,13.18,23.72,30.32v24.88"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "289.77 159.99 289.77 170.38 309.56 170.38 309.56 159.69"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "356.92 164.14 356.92 170.41 375.99 170.41 375.99 160.19"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "189.77 182.41 243.2 182.41 290.22 162.66 351.72 162.66 407.27 148.69 438.05 123.82"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M411.58,190.78c-8.03-1.88-15.81-7.1-19.97-14.23-.15,7.47,1.27,15.87,4.7,22.51,1.74,3.37,3.48,7.57,7.13,10.1-1.03,5.5-2.08,15.44,1.69,26.5,6.59,19.35,24.82,32.99,44.57,36,1.72.26,31.91,4.33,51.43-18.86,2.26-2.68,16.72-20.46,12-44.57-5.21-26.62-29.2-37.49-31.71-38.57-23.63-10.21-48.48-.28-61.85,11.94-3.65,3.34-6.24,6.65-7.98,9.19Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M453.65,210.79c-.55-.66-1.35-1.03-2.38-1.03-2.1,0-3.65,1.71-3.65,4.06s1.55,4.06,3.56,4.06c1.12,0,2.03-.5,2.6-1.35l2.31,1.73c-1.05,1.49-2.83,2.19-4.56,2.19-3.93,0-6.8-2.58-6.8-6.62s2.86-6.62,6.8-6.62c1.41,0,3.19.48,4.25,1.85l-2.14,1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M461.75,211.26c2.67,0,4.8,1.78,4.8,4.54s-2.14,4.54-4.8,4.54-4.8-1.78-4.8-4.54,2.14-4.54,4.8-4.54ZM461.75,217.98c1.33,0,2.14-.89,2.14-2.19s-.8-2.19-2.14-2.19-2.14.89-2.14,2.19.8,2.19,2.14,2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M468.12,211.47h2.56v1.17h.04c.36-.68,1.23-1.39,2.53-1.39,2.7,0,3.2,1.78,3.2,4.09v4.77h-2.67v-4.24c0-1-.02-2.28-1.39-2.28s-1.6,1.09-1.6,2.21v4.31h-2.67v-8.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M479.26,213.6h-1.76v-2.14h1.76v-1.53c0-1.89.48-3.49,3.38-3.49.53,0,1.07.04,1.57.16l-.12,2.26c-.3-.11-.55-.18-.87-.18-.85,0-1.28.27-1.28,1.41v1.37h1.98v2.14h-1.98v6.51h-2.67v-6.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M489.4,211.26c2.67,0,4.8,1.78,4.8,4.54s-2.14,4.54-4.8,4.54-4.8-1.78-4.8-4.54,2.14-4.54,4.8-4.54ZM489.4,217.98c1.33,0,2.14-.89,2.14-2.19s-.8-2.19-2.14-2.19-2.14.89-2.14,2.19.8,2.19,2.14,2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M495.77,211.47h2.67v1.39h.04c.57-1.05,1.32-1.6,2.49-1.6.3,0,.64.02.89.09v2.44c-.37-.11-.75-.18-1.14-.18-2.03,0-2.28,1.17-2.28,2.9v3.61h-2.67v-8.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M508.91,213.6h-2.35v2.88c0,.93.11,1.6,1.26,1.6.28,0,.85-.04,1.09-.25v2.22c-.59.21-1.25.27-1.87.27-1.78,0-3.15-.73-3.15-2.62v-4.11h-1.71v-2.14h1.71v-2.56h2.67v2.56h2.35v2.14Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M408.24,217.28s.18,1.69,1.06.81c.89-.89,2.71-4.46,8.34-6.94,5.63-2.47,3.84-2.95,3.84-2.95l-3.15.76-3.71,1.77-2.89,2.1-2.74,2.64-.63,1.47-.12.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M408.24,217.28s.18,1.69,1.06.81c.89-.89,2.71-4.46,8.34-6.94,5.63-2.47,3.84-2.95,3.84-2.95l-3.15.76-3.71,1.77-2.89,2.1-2.74,2.64-.63,1.47-.12.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M427.27,207.75s-.52-.26-.51.15c.02.41-1.04,3.33-8.29,7.18-7.24,3.84.89,4.12.89,4.12l8.92-3.18,1.38-5.27-1.58-2.34-.43-.46-.39-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M427.27,207.75s-.52-.26-.51.15c.02.41-1.04,3.33-8.29,7.18-7.24,3.84.89,4.12.89,4.12l8.92-3.18,1.38-5.27-1.58-2.34-.43-.46-.39-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M413.48,230.84s.84.62,1.08-.52c.27-1.11,2.37-3.08,10.16-8.7,7.8-5.62-4.42-.59-4.42-.59l-5.42,1.68-3.45,4.34,1.48,3.1.44.59.13.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M413.48,230.84s.84.62,1.08-.52c.27-1.11,2.37-3.08,10.16-8.7,7.8-5.62-4.42-.59-4.42-.59l-5.42,1.68-3.45,4.34,1.48,3.1.44.59.13.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M434.69,220.34l.31-.57v-.3s0-.48-.34-.17c-.33.3-1.45,1.37-6.87,7.17-5.42,5.8,1.61,1.76,1.61,1.76l4.11-3.45,1.43-3.54-.25-.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M434.69,220.34l.31-.57v-.3s0-.48-.34-.17c-.33.3-1.45,1.37-6.87,7.17-5.42,5.8,1.61,1.76,1.61,1.76l4.11-3.45,1.43-3.54-.25-.91Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M417.79,230.1c1.29-.84,3.17-1.64,4.68-2.29,6.91-2.95,11.92-5.31,12.51-8.34,0,.16,0,.33,0,.49,0,7.46-6.05,13.51-13.51,13.51-1.5,0-2.95-.25-4.31-.7-1.31-.65-1.11-1.55.61-2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M421.49,206.45c.89,0,1.75.09,2.59.25.68.25.84.64.4,1.12-.67.74-2.42,1.47-5.07,2.58-5.96,2.49-10.04,4.36-11.16,6.87,1.25-6.18,6.7-10.83,13.24-10.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M421.52,223.78c-6.33,2.8-9.92,5-8.04,7.07-2.68-1.98-4.61-4.93-5.26-8.33.21-3.26,5.81-5.96,12.55-8.88,4.71-2.05,9.02-4.17,6.5-5.89,2.93,1.39,5.28,3.8,6.59,6.78.44,2.56-3.05,5.15-12.33,9.25Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M417.79,230.1c1.29-.84,3.17-1.64,4.68-2.29,6.91-2.95,11.92-5.31,12.51-8.34,0,.16,0,.33,0,.49,0,7.46-6.05,13.51-13.51,13.51-1.5,0-2.95-.25-4.31-.7-1.31-.65-1.11-1.55.61-2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M421.49,206.45c.89,0,1.75.09,2.59.25.68.25.84.64.4,1.12-.67.74-2.42,1.47-5.07,2.58-5.96,2.49-10.04,4.36-11.16,6.87,1.25-6.18,6.7-10.83,13.24-10.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M421.52,223.78c-6.33,2.8-9.92,5-8.04,7.07-2.68-1.98-4.61-4.93-5.26-8.33.21-3.26,5.81-5.96,12.55-8.88,4.71-2.05,9.02-4.17,6.5-5.89,2.93,1.39,5.28,3.8,6.59,6.78.44,2.56-3.05,5.15-12.33,9.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M417.79,230.1c1.29-.84,3.17-1.64,4.68-2.29,6.91-2.95,11.92-5.31,12.51-8.34,0,.16,0,.33,0,.49,0,7.46-6.05,13.51-13.51,13.51-1.5,0-2.95-.25-4.31-.7-1.31-.65-1.11-1.55.61-2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M421.49,206.45c.89,0,1.75.09,2.59.25.68.25.84.64.4,1.12-.67.74-2.42,1.47-5.07,2.58-5.96,2.49-10.04,4.36-11.16,6.87,1.25-6.18,6.7-10.83,13.24-10.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M421.52,223.78c-6.33,2.8-9.92,5-8.04,7.07-2.68-1.98-4.61-4.93-5.26-8.33.21-3.26,5.81-5.96,12.55-8.88,4.71-2.05,9.02-4.17,6.5-5.89,2.93,1.39,5.28,3.8,6.59,6.78.44,2.56-3.05,5.15-12.33,9.25Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M455.79,224.04c-1.72,0-3.05,1.36-3.05,3.18s1.33,3.18,3.13,3.18c1,0,1.89-.37,2.6-1.28l-.66-.54c-.34.54-1.03,1.05-1.94,1.05-1.2,0-2.12-.96-2.22-2.17h5.04v-.39c0-1.65-1.06-3.01-2.9-3.03ZM453.67,226.76c0-1,1.01-1.94,2.12-1.94,1.23,0,1.97.79,1.97,1.94h-4.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M450.33,222.19v3.02h-.03c-.56-.81-1.55-1.16-2.35-1.16-1.89,0-3.22,1.36-3.22,3.18s1.33,3.18,3.22,3.18c.8,0,1.8-.35,2.35-1.16h.03v1.01h.85v-7.99c-.29,0-.57-.03-.85-.06ZM447.95,229.63c-1.41,0-2.29-1.05-2.29-2.4s.88-2.4,2.29-2.4,2.42,1.05,2.42,2.4-1.02,2.4-2.42,2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M473.98,225.21h-.03c-.7-.94-1.62-1.16-2.34-1.16-1.78,0-3.08,1.37-3.08,3.13s1.41,3.08,3.15,3.08c.88,0,1.72-.32,2.26-1.14h.03v1.09c0,1.31-.62,2.38-2.35,2.38-.97,0-1.81-.44-2.31-1.11l-.63.67c.78.83,1.71,1.22,2.91,1.22,2.71,0,3.25-1.84,3.25-3.15v-6h-.85v1.01ZM471.71,229.47c-1.27,0-2.25-1.06-2.25-2.33s.98-2.33,2.25-2.33c1.42,0,2.29,1.06,2.29,2.33.05,1.4-1.05,2.33-2.29,2.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M462.94,226.89l-.87-.21c-.79-.18-1.19-.39-1.19-.96,0-.65.66-.91,1.25-.91s1.05.32,1.31.81l.76-.5c-.39-.79-1.18-1.09-2.02-1.09-1.14,0-2.24.57-2.24,1.82,0,1.15,1.14,1.49,1.55,1.59l.83.19c.63.16,1.15.36,1.15.97,0,.7-.72,1.01-1.42,1.01s-1.24-.36-1.59-.91l-.74.5c.57.85,1.41,1.18,2.33,1.18,1.18,0,2.35-.54,2.35-1.86,0-.85-.63-1.46-1.47-1.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M479.65,224.04c-.8,0-1.65.47-2.03,1.12h-.03c0-.32,0-.65-.04-.97h-.88c.03.44.06,1.01.06,1.33v4.72h.85v-3.1c0-2.21,1.65-2.33,1.84-2.33,1.27,0,1.64.74,1.64,2.08v3.35h.85v-3.84c0-1.5-.74-2.37-2.28-2.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M466.36,221.25c-.31,0-.62.26-.62.62s.31.62.62.62.62-.26.62-.62-.31-.62-.62-.62Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 465.94,
    y: 224.2,
    width: 0.85,
    height: 6.05
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlancConfort);
export default __webpack_public_path__ + "static/media/Blanc-Confort.62b935e90a6ccd23e02afb5881e8075b.svg";
export { ForwardRef as ReactComponent };